import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FieldText, FormProps, ClosedContentProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {formatInterval} from "core/common/utils/dateUtils";
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {ActivityTemplate, EventTemplate} from "core/event/eventDomain";
import {observer} from "mobx-react";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import {Validate} from "core/form/validate";


@observer
class EventTemplateForm extends React.Component<FormProps<EventTemplate, EventTemplate>, undefined> {

  render() {


    let {dataObject, rootObject, entity, entities} = this.props;
    let fields = dataObject.getFormFields(definition.formName);
    let {comment, validFrom, validTo, profitCenter, language, defaultEmailSubject, templateIndex, emailFrom, replyTo, cc, bcc, toAddress, toAddressCode, invoiceTypeIds} = fields;

    let openContent = (
      <div>


        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...profitCenter.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...language.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...invoiceTypeIds.props} multi floatingLabelStyle={{top: 15}}/>
            <Validate field={invoiceTypeIds} value={invoiceTypeIds.props.value}/>
          </div>
          <div className="col-xs-12 col-sm-6">
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value} onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...defaultEmailSubject.props} multiLine={true} rows={2} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...emailFrom.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...replyTo.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...toAddressCode.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...toAddress.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...cc.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...bcc.props} />
          </div>
        </div>


        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );



    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} /> } validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}




const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<EventTemplate>) => (
  <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
    <ClosedFormField label={fields.templateIndex.textLabel} value={dataObject.templateIndex}/>
    <ClosedFormField label={fields.language.textLabel} value={dataObject.language}/>
    <ClosedFormField label={fields.invoiceTypeIds.textLabel} value={dataObject.invoiceTypeIds}/>
    <ClosedFormField label={fields.profitCenter.textLabel} value={dataObject.profitCenter}/>
    <ClosedFormField label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)}/>
    <ClosedFormField label={fields.emailFrom.textLabel} value={dataObject.emailFrom}/>
    <ClosedFormField label={fields.replyTo.textLabel} value={dataObject.replyTo}/>
    <ClosedFormField label={fields.toAddressCode.textLabel} value={dataObject.toAddressCode}/>
    <ClosedFormField label={fields.toAddress.textLabel} value={dataObject.toAddress}/>
    <ClosedFormField label={fields.cc.textLabel} value={dataObject.cc}/>
    <ClosedFormField label={fields.bcc.textLabel} value={dataObject.bcc}/>
    <ClosedFormField label={fields.defaultEmailSubject.textLabel} value={dataObject.defaultEmailSubject}/>
    <ClosedFormField label={fields.comment.textLabel} value={dataObject.comment}/>

  </ClosedFormBlock>
);



const definition: DefinitionType = {
  formName: 'EventTemplateForm',
  fields: [{
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }, {
    name: 'profitCenter'
  }, {
    name: 'language'
  }, {
    name: 'emailFrom'
  }, {
    name: 'replyTo'
  }, {
    name: 'cc'
  }, {
    name: 'toAddress'
  }, {
    name: 'toAddressCode'
  }, {
    name: 'bcc'
  }, {
    name: 'templateIndex'
  }, {
    name: 'defaultEmailSubject',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'invoiceTypeIds',
    omitNullOption: true,
  }]
};

export default createForm(definition, ClosedContent)(EventTemplateForm);



// WEBPACK FOOTER //
// ./src/core/event/component/eventTemplateForm.tsx